import { gql } from '@apollo/client';

/**
 * 获取尾程商选项列表
 */
export const GET_FINAL_MILE_CARRIER_OPTIONS = gql`
  query GetFinalMileCarrierOptions($includeSwiftX: Boolean!) {
    getFinalMileCarrierOptions(includeSwiftX: $includeSwiftX) {
      value
      name
      abbreviation
    }
  }
`;

/**
 * 尾程商选项接口
 * - abbreviation: TT 包牌三位缩写（来自后端 TT_BAGGING_SORTING_RULE_ALIASES），未配置时为 null
 */
export interface FinalMileCarrierOption {
  value: number;
  name: string;
  abbreviation: string | null;
}
